import { CommonModule, NgOptimizedImage } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { HeaderBigImageLink } from 'www-cms';
import { BigImageLinkComponent } from '../big-image-link/big-image-link.component';
import { mobileMenuAnimations } from './mobile-menu.animations';
import { Store } from '@ngxs/store';
import { HeaderActions, ShellState, ShellStateModel } from '../../shell.state';
import { ButtonComponent } from 'ui-elements/button';
import { RouterLink } from '@angular/router';
import { TheaterShowsListComponent } from '../theaterShowsList/theater-shows-list.component';

@Component({
  selector: 'ss-www-mobile-menu',
  imports: [
    CommonModule,
    NgOptimizedImage,
    TheaterShowsListComponent,
    BigImageLinkComponent,
    ButtonComponent,
    RouterLink,
  ],
  templateUrl: './mobile-menu.component.html',
  styleUrls: ['./mobile-menu.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  animations: mobileMenuAnimations,
})
export class MobileMenuComponent {
  private store = inject(Store);

  headerContent$ = this.store.select(ShellState.headerContent);
  openedMobileMenu$ = this.store.select(ShellState.openedMobileMenu);
  shows$ = this.store.select(ShellState.shows);
  bigImageLinks$ = this.store.select(ShellState.bigImageLinks);
  isMenuOrMobileMenuOpened$ = this.store.select(
    ShellState.isMenuOrMobileMenuOpened
  );
  shellState$ = this.store.select(ShellState.shellState);
  trackBigImageLink(index: number, item: HeaderBigImageLink) {
    return item.id;
  }

  dispatchSetMobileMenu(openedMobileMenu: ShellStateModel['openedMobileMenu']) {
    this.store.dispatch(
      new HeaderActions.SetOpenedMobileMenu(openedMobileMenu)
    );
  }

  dispatchPromoLinkClicked() {
    this.store.dispatch(new HeaderActions.PromoLinkClicked());
  }

  closeMobileMenu() {
    this.store.dispatch(new HeaderActions.SetMobileMenu(false));
    this.store.dispatch(new HeaderActions.SetOpenedMobileMenu('main'));
  }
}
